

export const USER_SESSION_KEY = "UserSession";